<template>
  <Spin fix v-show="show">
    <Icon type="ios-loading" size=18 class="spin-icon-load"></Icon>
    <div>{{$t('loading')}}</div>
  </Spin>
</template>

<script>
export default {
  props: {
    show: Boolean
  }
}
</script>

<style scoped lang="scss">
.spin-icon-load {
  animation: ani-spin 1s linear infinite;
}
@keyframes ani-spin {
  from { transform: rotate(0deg);}
  50%  { transform: rotate(180deg);}
  to   { transform: rotate(360deg);}
}
</style>